import React, { useState, useContext } from "react";
import axios from "axios";
import "./BuildDreamOrder.css";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const BuildDreamOrder = ({
  finalPrice = 0,
  currency = "IQD",
  selectedExterior,
  selectedInterior,
  selectedEquipment = [],
  orderEndpoint = "/api/VDreamOrders",
  carName = "VOYAH DREAM",
  labelsKey = "buildDream",
}) => {
  const { texts } = useContext(LanguageContext);
  const t = texts[labelsKey] || texts.buildDream || {};
  const cityLabels = t.cities || {};
  const displayCarName = t.modelName || carName;

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [form, setForm] = useState({
    firstName: "",
    surname: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    request: "",
    offerType: "",
    acceptPolicy: false,
    acceptNewsletter: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validate = () => {
    if (!form.firstName || !form.surname || !form.email || !form.phone)
      return "Please fill all required fields.";

    if (!form.offerType) return "Please select an offer type.";

    if (!form.acceptPolicy) return "You must accept the privacy policy.";

    return null;
  };

  const handleSubmit = async () => {
    const error = validate();
    if (error) {
      setErrorMsg(error);
      return;
    }

    setLoading(true);
    setErrorMsg("");
    setSuccess(false);

    try {
      await axios.post(`${API_BASE}${orderEndpoint}`, {
        firstName: form.firstName,
        surname: form.surname,
        email: form.email,
        phone: form.phone,
        address: form.address,
        city: form.city,
        request: form.request,
        offerType: form.offerType,
        selectedExterior: selectedExterior?.name ?? "Not selected",
        selectedInterior: selectedInterior?.name ?? "Not selected",
        selectedEquipment: selectedEquipment ?? [],
        finalPrice,
        currency,
      });

      setSuccess(true);
      setForm({
        firstName: "",
        surname: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        request: "",
        offerType: "",
        acceptPolicy: false,
        acceptNewsletter: false,
      });

      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error(err);
      setErrorMsg("Failed to submit order.");
    }

    setLoading(false);
  };

  return (
    <div className="order-wrapper">
      {success && (
        <div className="order-success">Your order was sent successfully!</div>
      )}

      {errorMsg && <div className="order-error">{errorMsg}</div>}

      <h2 className="order-section-title">{t.personalInfo}</h2>

      <div className="order-row">
        <div className="order-field">
          <label>{t.firstName}</label>
          <input name="firstName" value={form.firstName} onChange={handleChange} />
        </div>

        <div className="order-field">
          <label>{t.surname}</label>
          <input name="surname" value={form.surname} onChange={handleChange} />
        </div>
      </div>

      <div className="order-row">
        <div className="order-field">
          <label>{t.email}</label>
          <input name="email" value={form.email} onChange={handleChange} />
        </div>

        <div className="order-field">
          <label>{t.phone}</label>
          <input name="phone" value={form.phone} onChange={handleChange} />
        </div>
      </div>

      <h2 className="order-section-title">{t.addressSection}</h2>

      <div className="order-row">
        <div className="order-field">
          <label>{t.address}</label>
          <input name="address" value={form.address} onChange={handleChange} />
        </div>

        <div className="order-field">
          <label>{t.city}</label>
          <select name="city" value={form.city} onChange={handleChange}>
            <option value="">{t.select}</option>
            <option value="Erbil">{cityLabels.Erbil || "Erbil"}</option>
            <option value="Baghdad">{cityLabels.Baghdad || "Baghdad"}</option>
          </select>
        </div>
      </div>

      <h2 className="order-section-title">{t.request}</h2>

      <div className="order-field">
        <input
          name="request"
          placeholder={t.yourRequest}
          value={form.request}
          onChange={handleChange}
        />
      </div>

      <h2 className="order-section-title">{t.offerOn}</h2>

      <div className="order-radio-group">
        <label className="order-radio">
          <input
            type="radio"
            name="offerType"
            value="buy"
            checked={form.offerType === "buy"}
            onChange={handleChange}
          />{" "}
          {t.buying}
        </label>

        <label className="order-radio">
          <input
            type="radio"
            name="offerType"
            value="lease"
            checked={form.offerType === "lease"}
            onChange={handleChange}
          />{" "}
          {t.installment}
        </label>
      </div>

      <label className="order-checkbox">
        <input
          type="checkbox"
          name="acceptPolicy"
          checked={form.acceptPolicy}
          onChange={handleChange}
        />{" "}
        {t.privacyPolicy}
      </label>

      <label className="order-checkbox">
        <input
          type="checkbox"
          name="acceptNewsletter"
          checked={form.acceptNewsletter}
          onChange={handleChange}
        />{" "}
        {t.newsletter}
      </label>

      <button className="order-submit" onClick={handleSubmit} disabled={loading}>
        {loading ? t.submitting : t.submit}
      </button>

      <div className="order-price-section">
        <h3 className="order-car-name">{displayCarName}</h3>
      </div>
    </div>
  );
};

export default BuildDreamOrder;
